import { styled } from 'styled-components';

import { TWidgetIframeParentDimension } from '@lib/core/service/types/interface';

import { generateTypographyStyles } from '@components/web/src/foundations/Text/Text.styles';
import {
  TFontStyle,
  TFontType,
  TStyleWeight,
  TTextDecoration,
  TTextTransform,
  TTypographyVariants,
} from '@components/web/src/foundations/Text/types';
import { COLORS, SHADOWS } from '@components/web/src/styles';

export const StyledTextArea = styled.textarea<{
  $size?: TTypographyVariants;
  $weight?: TStyleWeight;
  $color?: string;
  $fontType?: TFontType;
  $fontStyle?: TFontStyle;
  $textDecoration?: TTextDecoration;
  $textTransform?: TTextTransform;
  $minHeight?: string;
  $dimension?: TWidgetIframeParentDimension;
}>`
  display: flex;
  width: 100%;
  align-self: stretch;
  padding: 10px 14px;
  min-height: ${({ $minHeight = '90px' }) => $minHeight};
  max-height: 240px;
  font-style: ${({ $fontStyle = 'normal' }) => $fontStyle};
  text-decoration: ${({ $textDecoration = 'none' }) => $textDecoration};
  text-transform: ${({ $textTransform = 'none' }) => $textTransform};
  border: 1px solid ${COLORS.gray[500]};
  background-color: ${COLORS.base.white};
  border-radius: 8px;
  box-shadow: ${SHADOWS.xs};

  ${({ $size, $weight, $fontType, $dimension, theme }) =>
    generateTypographyStyles(
      $size,
      $fontType,
      $weight,
      theme?.isKioskRootElementType,
      theme?.retailerFonts,
      $dimension,
    )}
`;
